module.exports = __webpack_public_path__ + "static/media/the-game-cricket-reg.5044eb8b.png";